<app-navbar></app-navbar>

<div class="business-builder">
  <div class="left">
    <app-brochure-button
         fileName="Gold package.pdf"
         label="Download Brochure"
         className="outline-btn">
      </app-brochure-button>

    <h1> GOLD PACKAGE </h1>

    <h2> WHY CHOOSE <br>NexGen Executive Coaching Academy?</h2>

    <h5>FLEXIBILITY:</h5>
    <p>Start and complete your training at your own pace.</p>

    <h5>PRACTICAL APPROACH:</h5>
    <p>Learn from experienced Fortune 500 business professionals.</p>

    <h5>IN-DEPTH MODERN CONTENT:</h5>
    <p>Comprehensive training including AI Coaching, neuroscience, advanced coaching frameworks,
      cultural intelligence, cognitive behavioral techniques, and emotional intelligence.</p>
  </div>

  <div class="right">
    <div class="image">
            <img src="../../../assets/salesCertification/Screenshot 2025-07-23 010203.png" alt="">
        </div>
    <div class="contant">
      <div class="contant1">
        <h1> PROGRAM OVERVIEW </h1>
        <p>
          NexGen Executive Coaching Academy Gold Package is designed for aspiring Executive Coaches who want to
          earn a certification without pursuing ICF accreditation. This 60-hour blended training
          combines live, interactive sessions with self-paced online learning.
        </p>
      </div>
      <div class="contant2">
        <h5>nexgencoaches.com</h5>
        <h1>NexGen Executive Coaching Academy</h1>
        <p>Copyright NexGen Executive Coaching Academy, L.L.C. All rights reserved, not for duplication or re-use.</p>
      </div>
    </div>
  </div>
</div>

<div class="main2">
  <div class="left">
    <img src="../../../assets/Brochures/3-day gold.PNG" alt="Gold Package Overview">
  </div>

  <div class="middle">
    <p>Program Cost: $7,995</p>
    <h2>NEXGEN EXECUTIVE COACHING ACADEMY GOLD PACKAGE</h2>
    <p>Earn your Professional Coaching Certification with 60 hours of elite-level training.</p>

    <h5>CERTIFICATION DETAILS:</h5>
    <ul>
      <li>Total Training: 60 hours (Synchronous + Asynchronous)</li>
      <li>Completion Time: 2–3 months</li>
      <li>Includes Business Builder Workshop</li>
      <li>Individual EQ2.0i Assessment with readout</li>
      <li>Unlimited Live Interactive Webinars</li>
      <li>30 Hours of Self-paced LMS Learning</li>
      <li>Assessment Quiz</li>
    </ul>

    <h5>EXCLUSIVE FEATURES:</h5>
    <ul class="prerequisits">
      <li>One-Year Access to AI-Driven LMS Platform</li>
      <li>Real-Time Barter Coaching Platform</li>
      <li>Customizable AI Co-Pilot Coach Assistant</li>
      <li>Patented AI-Driven Coaching Frameworks</li>
      <li>Specialty Certifications Access</li>
      <li>Patented NexGen Executive Coaching Academy App (Android/iOS)</li>
      <li>Flexible Platinum Upgrade Options (Upgrade Anytime)</li>
      <li>30-Day Risk-Free Guarantee</li>
    </ul>

    <p class="copyright">Copyright NexGen Executive Coaching Academy, L.L.C. All rights reserved, not for duplication or re-use.</p>
    <p class="bottom">nexgencoaches.com</p>
  </div>

  <div class="right">
    <img src="../../../assets/Brochures/gold-image.PNG" alt="Gold Package Curriculum Highlights">
  </div>
</div>

<app-footer></app-footer>
